var _div, _ErrorViewOnAchieveme;
import { useCallback } from 'react';
import cn from 'clsx';
import { Loader } from '@crehana/compass.ui';
import { PlayroomBadgeCard } from "../PlayroomBadgeCard";
import useUserAchievementList from "../shared/hooks/useUserAchievements";
import { redirectTo } from "../utils";
import ErrorViewOnAchievements from "./components/ErrorViewOnAchievements";
import HelpBadges from "./components/HelpBadges";
import { usePlayroomAchievementsTranslations } from "./hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PlayroomAchievementsSection = function PlayroomAchievementsSection(_ref) {
  var organizationSlug = _ref.organizationSlug,
    organizationId = _ref.organizationId,
    className = _ref.className,
    style = _ref.style,
    dataTestid = _ref['data-testid'];
  var _useUserAchievementLi = useUserAchievementList(organizationId, organizationSlug),
    data = _useUserAchievementLi.data,
    loading = _useUserAchievementLi.loading,
    error = _useUserAchievementLi.error;
  var _usePlayroomAchieveme = usePlayroomAchievementsTranslations(),
    t = _usePlayroomAchieveme.t;
  var onClickCTA = useCallback(function (achievement) {
    return function () {
      return redirectTo(achievement.urlRedirect);
    };
  }, []);
  var renderItems = useCallback(function () {
    return /*#__PURE__*/_jsx("div", {
      role: "grid",
      className: "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-1.6 sm:tw-gap-2.4",
      children: data.map(function (item, index) {
        var _item$icon;
        return /*#__PURE__*/_jsx(PlayroomBadgeCard, {
          achievementId: item.originalId,
          badgeTagLabel: item.tag,
          badgeTitle: item.title,
          coins: item.coins,
          completed: item.completed,
          animations: {
            order: index + 1
          },
          badgeTagColor: item.color,
          onClickCTA: onClickCTA(item),
          ctaLabel: item.ctaLabel,
          achievementLogoSrc: (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.url,
          subjectName: item.subjectName,
          role: "gridcell"
        }, item.originalId);
      })
    });
  }, [data, onClickCTA]);
  var renderContent = useCallback(function () {
    if (loading) {
      return _div || (_div = /*#__PURE__*/_jsx("div", {
        className: "tw-flex tw-justify-center tw-items-center",
        children: /*#__PURE__*/_jsx(Loader, {})
      }));
    }
    if (error) {
      return _ErrorViewOnAchieveme || (_ErrorViewOnAchieveme = /*#__PURE__*/_jsx(ErrorViewOnAchievements, {}));
    }
    return renderItems();
  }, [error, loading, renderItems]);
  return /*#__PURE__*/_jsxs("section", {
    className: className,
    style: style,
    "data-testid": dataTestid,
    children: [/*#__PURE__*/_jsxs("section", {
      className: "tw-rounded-1.2 tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700 tw-p-2 sm:tw-p-2.4 dark:tw-text-neutral-light-100 tw-mb-1.6",
      children: [/*#__PURE__*/_jsxs("header", {
        className: "tw-flex tw-items-center tw-mb-1.6",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "tw-font-subtitle3 sm:tw-font-subtitle2 tw-mr-0.8",
          children: t('PAS_TITLE')
        }), /*#__PURE__*/_jsx("div", {
          className: "tw-text-1.2 tw-font-semibold tw-px-0.4 tw-bg-primary-light-200 dark:tw-bg-primary-dark-200 tw-text-primary-light-500 dark:tw-text-primary-dark-600 tw-h-1.6 tw-rounded-0.4",
          children: data.length
        })]
      }), /*#__PURE__*/_jsx("p", {
        className: "tw-font-body3 tw-mb-2 sm:tw-mb-2.4",
        children: t('PAS_DESCRIPTION')
      }), renderContent()]
    }), /*#__PURE__*/_jsx(HelpBadges, {
      organizationId: organizationId,
      "data-testid": "playroom-help-badges",
      className: cn('tw-rounded-1.2 sm:tw-mb-2',
      // Paddings
      'tw-p-2 sm:tw-p-2.4',
      // Backgrounds
      'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700')
    })]
  });
};
export default PlayroomAchievementsSection;